import {Button, ButtonProps} from './Button';
import {Link, LinkProps} from './Link';

export enum ButtonLinkMods {
  Link = 'link',
  LinkFaded = 'linkFaded',
  LinkBordered = 'linkBordered',
  LinkInherit = 'linkInherit',
  LinkPrimary = 'linkPrimary',
  ButtonYellow = 'buttonYellow',
  ButtonTransparent = 'buttonTransparent',
  ButtonPrimary = 'buttonPrimary',
  ButtonSecondary = 'buttonSecondary',
  ButtonTertiary = 'buttonTertiary',
  ButtonQuaternary = 'buttonQuaternary',
  ButtonHexadecimal = 'buttonHexadecimal',
  ButtonDisabled = 'buttonDisabled',
  ButtonTab = 'buttonTab',
  ButtonWhiteBordered = 'buttonWhiteBordered',
  ButtonGreenBordered = 'buttonGreenBordered',
  Initial = 'initial',
}

export enum ButtonLinkSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
}

export type ButtonLinkProps = ButtonProps | LinkProps;

// Договорились, что объединяем компоненты Button и Link в один - ButtonLink,
// потому что в проектах кнопки и ссылки выглядят почти всегда одинаково.
// Различие бывает только в поведении - отправить
// на отдельную страницу или выполнить действие
export function ButtonLink(props: LinkProps): JSX.Element;
export function ButtonLink(props: ButtonProps): JSX.Element;
export function ButtonLink(props: ButtonLinkProps): JSX.Element {
  return isLinkProps(props) ? <Link {...props} /> : <Button {...props} />;
}

function isLinkProps(props: ButtonLinkProps): props is LinkProps {
  return typeof props.href === 'string';
}
